/* eslint-disable camelcase -- Firestore field names are the persisted Turkish schema. */
// The feed's photo flag is a cached hint, never the source of truth.
// Removal deletes the private metadata; moderation changes its status.
export function canShowLeagueMatchPhoto(
  matchId: string,
  match: { mac_durum?: number; lig_temel_id?: string } | undefined,
  photo:
    | { mac_id?: string; lig_temel_id?: string; durum?: string; storage_yolu?: string }
    | undefined,
  event: { tur?: string; lig_temel_id?: string; veri?: { mac_id?: string } } | undefined,
): boolean {
  return !!(
    /^[A-Za-z0-9_-]{1,128}$/.test(matchId) &&
    match?.mac_durum === 2 &&
    match.lig_temel_id &&
    event?.tur === 'mac_sonucu' &&
    event.veri?.mac_id === matchId &&
    event.lig_temel_id === match.lig_temel_id &&
    photo?.mac_id === matchId &&
    photo.lig_temel_id === match.lig_temel_id &&
    photo.durum === 'bekliyor' &&
    typeof photo.storage_yolu === 'string' &&
    photo.storage_yolu.startsWith(`league-match-photos/${matchId}/`) &&
    photo.storage_yolu.length > `league-match-photos/${matchId}/`.length
  );
}

// Oyuncu fotoğrafı rezerve/sonuç girilmiş maçta, onaydan sonra da not süresiyle aynı 4 gün ekler
// (LG-63). Onay zamanı akıştaki `mac_<id>` olayının oluşturma zamanıdır.
export const PLAYER_PHOTO_WINDOW_MS = 4 * 24 * 60 * 60 * 1000;

export function canPlayerAddMatchPhoto(status: unknown, approvedAt: unknown, now = Date.now()): boolean {
  if (status === 1 || status === 4) return true;
  return status === 2 && typeof approvedAt === 'number' && approvedAt > 0 &&
    now < approvedAt + PLAYER_PHOTO_WINDOW_MS;
}
